import { manageGroup } from 'core/permissions';

export default {
  global: manageGroup,
  local: 'reporting.campaign_report_local',
  local_managed: 'reporting.campaign_report_local_managed',
};
